var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 3H12C8.68629 3 6 5.68629 6 9V27C6 30.3137 8.68629 33 12 33H26.25C29.5637 33 32.25 30.3137 32.25 27V9C32.25 5.68629 29.5637 3 26.25 3Z",
    stroke: "#03122E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.885 20.6112C14.9419 21.243 12.4689 22.5331 13.9751 24.1474C14.7109 24.936 15.5304 25.5 16.5606 25.5H22.4394C23.4696 25.5 24.2892 24.936 25.0249 24.1474C26.5311 22.5331 24.0582 21.243 23.115 20.6112C20.9032 19.1296 18.0967 19.1296 15.885 20.6112Z",
    stroke: "#03122E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5C22.5 15.1569 21.1569 16.5 19.5 16.5C17.8431 16.5 16.5 15.1569 16.5 13.5C16.5 11.8431 17.8431 10.5 19.5 10.5C21.1569 10.5 22.5 11.8431 22.5 13.5Z",
    stroke: "#03122E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9H3.75M7.5 18H3.75M7.5 27H3.75",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.7c679a0bcb6874d25587d149c971089b.svg";
export { ForwardRef as ReactComponent };